<template>
    <v-alert v-model="visible" dense outline :timeout="timeout" class="rounded-0" transition="expand-transition-x"
        color="secondary" outlined>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form @submit.prevent="submit">
                <v-row>
                    <v-col cols="12" md="12" class="d-flex flex-row align-start">
                        <v-icon color="secondary" class="mr-2">mdi-information-outline</v-icon>
                        <div class="text-body-1" v-html="formattedMessage">
                        </div>
                    </v-col>
                </v-row>
                <!--  <v-row v-if="puededesestimar">
                    <v-col cols="12" md="7" class="d-flex justify-start pt-0">
                        <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                            <v-checkbox v-model="checkbox" :error-messages="v.errors[0]" input-value="false" value dense
                                color="secondary">
                                <template v-slot:label>
                                    <div
                                        :class="(checkbox) ? `font-weight-regular secondary--text` : `black--text font-weight-regular`">
                                        Confirmo que quiero desestimar mi solicitud de NIVEL {{
                                            opcionNivelAfiliado.nivelPedido }}.
                                    </div>
                                </template>
</v-checkbox>
</ValidationProvider>
</v-col>
<v-col cols="12" md="5" class="d-flex justify-end align-center pt-0 ">
    <v-btn :disabled="invalid" type="submit" class="pa-5" color="primary" elevation="0" :loading="loading">
        <v-icon class="mr-2">mdi-send-outline</v-icon>
        {{ accion }} {{ opcionNivelAfiliado.nivelPedido }}
    </v-btn>
</v-col>
</v-row> -->
            </v-form>
        </ValidationObserver>
    </v-alert>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            visible: true,
            checkbox: false,
            loading: false,
        }
    },
    methods: {

        close() {
            this.visible = false
        },
        submit() {
            this.loading = true
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.$emit('accionBtn')
                }
            }).finally(() => {
                this.loading = false
            })
        },
        formatText(text) {
            if (!text) return '';

            let nivelDisplay = this.opcionNivelAfiliado.nivelPedido;

            // Usar el valor pasado en entramite si existe
            if (this.entramite) {
                nivelDisplay = this.entramite;
            }

            // Reemplazar {nivel} por el valor actual
            let replacedText = text.replace(/{nivel}/gi, `${nivelDisplay}`);
            // Reemplazar {anio} por el valor actual
            replacedText = replacedText.replace(/{anio}/gi, `${this.opcionNivelAfiliado.anioOpcionNivel}`);
            // Palabras/frases a resaltar
            const highlights = [
                'PENDIENTE',
                'APROBADO',
                'RECHAZADO',
                'DESESTIMADO',
                `Opción de NIVEL ${this.opcionNivelAfiliado.nivelPedido} para el ${this.opcionNivelAfiliado.anioOpcionNivel}`,
            ];
            highlights.forEach(word => {
                const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escaped, 'gi');
                replacedText = replacedText.replace(regex, match => `<b>${match}</b>`);
            });
            return replacedText;
        }
    },
    computed: {
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado']),

        formattedMessage() {
            return this.formatText(this.message);
        }
    },
    mounted() {
        if (this.timeout) {
            setTimeout(() => {
                this.close();
            }, this.timeout);
        }
    },
    props: ['title', 'message', 'timeout', 'dismissible', 'color', 'accion', 'url', 'icon', 'entramite', 'puededesestimar']
}

</script>